export default "__VITE_ASSET__C$OQ7FCa__"